/* V4O — parche del widget de bundles (Pumper)   v2 · 13/08/2026
   Bug: el primer escalon (x1) no sincroniza [name=quantity], que se queda con
   el multiplicador del escalon mas alto. Quien anade sin tocar el selector se
   lleva 3x (o 10x) lo que cree comprar.
   v2: la v1 solo cubria el boton dentro del formulario. Se escapaban el boton
   fijo (sticky, va FUERA del form) y "COMPRAR AHORA - PAGO EXPRES" (type=button,
   sin name=add). Ahora se sincroniza ante cualquier pulsacion, en fase de
   captura, antes de que corra el codigo del tema o del app.
   Si la pagina no tiene radios de Pumper no hace nada. */
(function () {
  'use strict';
  var SEL_RADIO = 'input[name="cb"]';
  var SEL_FORM  = 'form[action*="/cart/add"]';

  function sync() {
    var marcado = document.querySelector(SEL_RADIO + ':checked');
    if (!marcado) return false;                    // pagina sin bundles -> no tocar nada
    var mult = parseInt(marcado.value, 10);
    if (!mult || mult < 1) return false;
    var cambiado = false;
    document.querySelectorAll(SEL_FORM).forEach(function (form) {
      form.querySelectorAll('[name="quantity"]').forEach(function (input) {
        if (input.value !== String(mult)) { input.value = String(mult); cambiado = true; }
      });
    });
    return cambiado;
  }

  // Cualquier pulsacion, en captura: cubre el boton normal, el sticky de fuera
  // del formulario, el de pago expres y cualquiera que anadan en el futuro.
  ['pointerdown', 'mousedown', 'click'].forEach(function (ev) {
    document.addEventListener(ev, sync, true);
  });
  document.addEventListener('submit', function (e) {
    if (e.target && e.target.matches && e.target.matches(SEL_FORM)) sync();
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') sync();
  }, true);

  // al cambiar de escalon (despues de que el radio actualice su estado)
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'cb') setTimeout(sync, 0);
  }, true);

  // Pumper monta su widget de forma asincrona
  var intentos = 0;
  var t = setInterval(function () { sync(); if (++intentos > 40) clearInterval(t); }, 250);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else { sync(); }
})();
